module.exports = __webpack_public_path__ + "static/media/design-illustration.3ac89e2d.svg";